webpackJsonp([167671710665089],{

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//const Image = styled.img`
	//  display: block;
	//  max-width: 100%;
	//  transition: 175ms ease-in-out;
	//`
	
	var ImageShift = function (_Component) {
	  _inherits(ImageShift, _Component);
	
	  function ImageShift(props) {
	    _classCallCheck(this, ImageShift);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      mounted: false
	    };
	    return _this;
	  }
	
	  ImageShift.prototype.componentDidMount = function componentDidMount() {
	    this.setState({
	      mounted: true
	    });
	  };
	
	  ImageShift.prototype.render = function render() {
	    var _props = this.props,
	        src = _props.src,
	        alt = _props.alt,
	        mounted = _props.mounted,
	        color = _props.color,
	        className = _props.className;
	
	    var classT = className;
	    if (mounted) {
	      classT = "image-loading";
	    }
	    if (color) {
	      classT = classT + " background-color-" + color;
	    }
	    //<img src={src} className={ mounted &&
	    //        "image-loading"} />
	    return _react2.default.createElement("img", { src: src, className: classT, alt: alt });
	  };
	
	  return ImageShift;
	}(_react.Component);
	
	exports.default = ImageShift;
	module.exports = exports["default"];

/***/ }),

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(7);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _BannerLanding = __webpack_require__(9);
	
	var _BannerLanding2 = _interopRequireDefault(_BannerLanding);
	
	var _ImageShift = __webpack_require__(15);
	
	var _ImageShift2 = _interopRequireDefault(_ImageShift);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//import searchEngine from '../assets/images/parts-de-marche-moteurs-recherche-france.png';
	//import wp from '../assets/images/wordpress.jpg';
	//import joomla from '../assets/images/Joomla.png';
	//import ps from '../assets/images/prestashop-logo.png';
	//import woo from '../assets/images/woocommerce.png';
	//import vitrine from '../assets/images/site-vitrine.jpg';
	//import reactlogo from '../assets/images/react-logo.png';
	//import applelogo from '../assets/images/apple-gray-logo.png';
	//import androidlogo from '../assets/images/android-logo.png';
	//import dev from '../assets/images/web_programming.jpg';
	
	
	var pageTitle = "Sites & Applis";
	var pageContent = ["Besoin de visibilité en ligne pour votre activité ?", "Envie de vous lancer dans le e-commerce ?", "Une idée d’application à développer ?"];
	//const pageContent = ["Vous voulez optimiser la visibilité en ligne de votre activité ?","Vous souhaitez vous lancer dans le e-commerce ?","Vous avez une idée d’application à développer ?"];
	var icon = "desktop";
	
	var Generic = function Generic(props) {
		return _react2.default.createElement(
			'div',
			{ style: props.transition && props.transition.style },
			_react2.default.createElement(
				_reactHelmet2.default,
				null,
				_react2.default.createElement(
					'title',
					null,
					'Web 2 Alpes - Cr\xE9ation de sites Internet et applications'
				),
				_react2.default.createElement('meta', { name: 'description', content: 'Creation de sites internet et d\'applications mobiles (Android, IOS)' }),
				_react2.default.createElement('meta', { name: 'language', content: 'fr-FR' }),
				_react2.default.createElement('meta', { 'http-equiv': 'content-type', content: 'text/html; charset=UTF-8' }),
				_react2.default.createElement('meta', { 'http-equiv': 'content-language', content: 'fr-FR' })
			),
			_react2.default.createElement(_BannerLanding2.default, { icon: icon, title: pageTitle, content: pageContent, particles: 'cms' }),
			_react2.default.createElement(
				'div',
				{ id: 'main', className: 'alt' },
				_react2.default.createElement(
					'section',
					{ className: 'tiles' },
					_react2.default.createElement(
						'article',
						{ className: 'full-medium' },
						_react2.default.createElement(
							'div',
							{ className: 'inner' },
							_react2.default.createElement(
								'header',
								{ className: 'major' },
								_react2.default.createElement(
									'h2',
									null,
									'Votre site Internet'
								)
							),
							_react2.default.createElement(
								'p',
								{ className: 'preul' },
								'De plus en plus d\u2019artisans, commerces, associations et soci\xE9t\xE9s de services / loisirs cr\xE9ent leur ',
								_react2.default.createElement(
									'strong',
									null,
									'site vitrine'
								),
								' ou ',
								_react2.default.createElement(
									'strong',
									null,
									'e-commerce'
								),
								'. Je vous aide \xE0 cr\xE9er le v\xF4tre :'
							),
							_react2.default.createElement(
								'ul',
								{ className: 'snow' },
								_react2.default.createElement(
									'li',
									null,
									_react2.default.createElement(
										'strong',
										null,
										'conception'
									),
									' (graphisme, design, choix des fonctionnalit\xE9s...),'
								),
								_react2.default.createElement(
									'li',
									null,
									_react2.default.createElement(
										'strong',
										null,
										'r\xE9alisation'
									),
									' (d\xE9veloppement ou int\xE9gration),'
								),
								_react2.default.createElement(
									'li',
									null,
									_react2.default.createElement(
										'strong',
										null,
										'configuration'
									),
									' (optimisation, r\xE9f\xE9rencement, s\xE9curit\xE9...),'
								),
								_react2.default.createElement(
									'li',
									null,
									_react2.default.createElement(
										'strong',
										null,
										'mise en ligne'
									),
									' (r\xE9servation du nom de domaine, choix de l\u2019h\xE9bergeur...),'
								),
								_react2.default.createElement(
									'li',
									null,
									_react2.default.createElement(
										'strong',
										null,
										'gestion'
									),
									' (je le modifie selon vos besoins ou vous forme \xE0 le faire seul).'
								)
							),
							_react2.default.createElement(
								'p',
								{ className: 'bordertop' },
								'Pour discuter sans engagement de votre projet ',
								_react2.default.createElement(
									'strong',
									null,
									_react2.default.createElement(
										_gatsbyLink2.default,
										{ to: '#contact' },
										'contactez moi !'
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'article',
						{ className: 'full-medium' },
						_react2.default.createElement(
							'div',
							{ className: 'inner' },
							_react2.default.createElement(
								'header',
								{ className: 'major' },
								_react2.default.createElement(
									'h2',
									null,
									'Un site personnalise'
								)
							),
							_react2.default.createElement(
								'p',
								{ className: 'preul' },
								'Carte de visite, vitrine ou e-commerce, les ',
								_react2.default.createElement(
									'strong',
									null,
									'CMS  (syst\xE8me de gestion de contenu)'
								),
								' vous aident \xE0 cr\xE9er un site unique \xE0 partir de milliers\xA0: '
							),
							_react2.default.createElement(
								'ul',
								{ className: 'snow' },
								_react2.default.createElement(
									'li',
									null,
									_react2.default.createElement(
										'strong',
										null,
										'd\u2019extensions'
									),
									' pour int\xE9grer des fonctionnalit\xE9s (portfolio, blog, r\xE9servation, paiement s\xE9curis\xE9...)'
								),
								_react2.default.createElement(
									'li',
									null,
									_react2.default.createElement(
										'strong',
										null,
										'de th\xE8mes'
									),
									' pour personnaliser le graphisme.'
								)
							),
							_react2.default.createElement(
								'p',
								null,
								'Et pour un projet encore plus sp\xE9cifique, je d\xE9veloppe ',
								_react2.default.createElement(
									'strong',
									null,
									'votre application enti\xE8rement sur mesure'
								),
								'.'
							)
						)
					),
					_react2.default.createElement(
						'article',
						{ className: 'full-medium' },
						_react2.default.createElement(
							'div',
							{ className: 'inner' },
							_react2.default.createElement(
								'header',
								{ className: 'major' },
								_react2.default.createElement(
									'h2',
									null,
									'Un site economique'
								)
							),
							_react2.default.createElement(
								'p',
								null,
								'Les CMS permettent ',
								_react2.default.createElement(
									'strong',
									null,
									'un gain de temps et d\u2019argent consid\xE9rable'
								),
								' en offrant aux professionnels de multiples solutions \xE0 leurs probl\xE9matiques vari\xE9es.'
							),
							_react2.default.createElement(
								'p',
								null,
								'Parmi toutes les applications gratuites du march\xE9, je vous aide \xE0 ',
								_react2.default.createElement(
									'strong',
									null,
									'choisir la plus pertinente'
								),
								' pour votre projet et \xE0 ',
								_react2.default.createElement(
									'strong',
									null,
									'exploiter au mieux son potentiel'
								),
								'.'
							),
							_react2.default.createElement(
								'p',
								{ className: 'bordertop' },
								'Les CMS les plus utilis\xE9s\xA0: ',
								_react2.default.createElement(
									'a',
									{ href: 'https://fr.wordpress.org/', target: '_blank' },
									_react2.default.createElement(
										'strong',
										null,
										'Wordpress'
									)
								),
								', ',
								_react2.default.createElement(
									'a',
									{ href: 'https://fr.wordpress.org/plugins/woocommerce/', target: '_blank' },
									_react2.default.createElement(
										'strong',
										null,
										'Woocommerce'
									)
								),
								', ',
								_react2.default.createElement(
									'a',
									{ href: 'https://addons.prestashop.com/fr/3-themes-prestashop?utm_source=prestashop.com&utm_medium=main-menu&utm_campaign=internal-linking&utm_content=theme', target: '_blank' },
									_react2.default.createElement(
										'strong',
										null,
										'Prestashop'
									)
								),
								', ',
								_react2.default.createElement(
									'a',
									{ href: 'https://www.drupal.org/', target: '_blank' },
									_react2.default.createElement(
										'strong',
										null,
										'Drupal'
									)
								),
								' et ',
								_react2.default.createElement(
									'a',
									{ href: 'https://magento.com/schedule-a-demo', target: '_blank' },
									_react2.default.createElement(
										'strong',
										null,
										'Magento'
									)
								),
								'.'
							)
						)
					),
					_react2.default.createElement(
						'article',
						{ className: 'full-medium' },
						_react2.default.createElement(
							'div',
							{ className: 'inner' },
							_react2.default.createElement(
								'header',
								{ className: 'major' },
								_react2.default.createElement(
									'h2',
									null,
									'Mes garanties'
								)
							),
							_react2.default.createElement(
								'ul',
								{ className: 'snow' },
								_react2.default.createElement(
									'li',
									null,
									_react2.default.createElement(
										'strong',
										null,
										'Une qualit\xE9 professionnelle'
									),
									' aux derniers standards du web'
								),
								_react2.default.createElement(
									'li',
									null,
									_react2.default.createElement(
										'strong',
										null,
										'Un site optimis\xE9 et s\xE9curis\xE9'
									)
								),
								_react2.default.createElement(
									'li',
									null,
									'La possibilit\xE9 de consulter ma ',
									_react2.default.createElement(
										'strong',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'http://www.madecommunication.fr', target: '_blank' },
											'collaboratrice graphiste'
										)
									),
									' (logo, design...)'
								),
								_react2.default.createElement(
									'li',
									null,
									_react2.default.createElement(
										'strong',
										null,
										'Un design responsive'
									),
									'\xA0(votre site s\u2019adapte \xE0 tous types d\u2019\xE9cran)'
								),
								_react2.default.createElement(
									'li',
									null,
									_react2.default.createElement(
										'strong',
										null,
										'Un r\xE9f\xE9rencement naturel'
									),
									' optimis\xE9\xA0sur Google\xA0(vos clients vous trouvent)'
								),
								_react2.default.createElement(
									'li',
									null,
									_react2.default.createElement(
										'strong',
										null,
										'Un accompagnement'
									),
									' \xE0 tous les niveaux (en fonction de vos besoins)'
								),
								_react2.default.createElement(
									'li',
									null,
									_react2.default.createElement(
										'strong',
										null,
										'Une documentation'
									),
									' avec toutes les donn\xE9es techniques (pour faire \xE9voluer votre site avec ou sans mon aide)'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'bordertop' },
								_react2.default.createElement(
									'nav',
									null,
									_react2.default.createElement(
										_gatsbyLink2.default,
										{ to: '#contact', className: 'button small' },
										'Devis gratuit ',
										_react2.default.createElement('i', { className: 'icon fa-euro' })
									),
									_react2.default.createElement(
										_gatsbyLink2.default,
										{ to: '/pack-site-vitrine/', className: 'button small' },
										'Pack vitrine ',
										_react2.default.createElement('i', { className: 'icon fa-wordpress' })
									),
									_react2.default.createElement(
										_gatsbyLink2.default,
										{ to: '/pack-e-commerce/', className: 'button small' },
										'Pack e-commerce ',
										_react2.default.createElement('i', { className: 'icon fa-shopping-cart' })
									)
								)
							)
						)
					)
				)
			)
		);
	};
	
	exports.default = Generic;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-creation-sites-internet-et-applications-js-d05c146ecc0f2a349da1.js